// extracted by mini-css-extract-plugin
export default {"TextContainer":"TextInput_TextContainer__m5Hai","Text":"TextInput_Text__Bghp0","ValidInput":"TextInput_ValidInput__7yx2p"};